<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Session Suspended! 🔐</h2>
        <p class="mb-2">Your current Management session has been suspended.</p>
        <b-button variant="primary" class="mb-1 btn-sm-block" @click="logout">Logout</b-button>
        <!-- <b-img fluid :src="imgUrl" alt="Session Suspended" /> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import store from '@/store/index';
import useJwt from '@/auth/jwt/useJwt';

export default {
  components: {
    BLink,
    BImg,
    BButton,
    VuexyLogo,
  },
  data() {
    return {
      downImg: "require('@/assets/images/pages/not-authorized.svg'),",
    };
  },
  methods: {
    logout() {
      return useJwt.logout();
    },
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = "require('@/assets/images/pages/not-authorized-dark.svg');";
        return this.downImg;
      }
      return this.downImg;
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
